/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".description[_ngcontent-%COMP%]{font-style:italic}ion-img.md.hydrated[_ngcontent-%COMP%]{height:auto;width:50%}@media screen and (max-width:420px){.video-iframe[_ngcontent-%COMP%]{width:50%;height:45vh}}@media screen and (min-width:801px){.video-iframe[_ngcontent-%COMP%]{width:100%;height:75vh}}"];
export { styles as styles };
